import { useDroppable } from '@dnd-kit/core';
import { isToday, parseISO } from 'date-fns';
import type { ReactNode } from 'react';
import { PlannerNowIndicator } from './PlannerNowIndicator';

interface PlannerDayColumnProps {
  date: string;
  startHour: number;
  endHour: number;
  gridHeight: number;
  pxPerHour: number;
  children: ReactNode;
}

export function PlannerDayColumn({ date, startHour, endHour, gridHeight, pxPerHour, children }: PlannerDayColumnProps) {
  const { setNodeRef } = useDroppable({
    id: `planner-day-${date}`,
  });

  const today = isToday(parseISO(date));

  return (
    <div
      ref={setNodeRef}
      data-date={date}
      data-start-hour={startHour}
      data-px-per-hour={pxPerHour}
      className={`relative border-l border-border-subtle/30 ${today ? 'bg-accent/[0.02]' : ''}`}
      style={{ height: gridHeight }}
    >
      {children}
      {today && (
        <PlannerNowIndicator startHour={startHour} endHour={endHour} pxPerHour={pxPerHour} />
      )}
    </div>
  );
}
